// extracted by mini-css-extract-plugin
module.exports = {"page":"_1wtKtQEq","bodyContainer":"_3K5uZhsN","articleManagementSideBarContainer":"hmmllv3n","rightContent":"_3jIK47ii"};